var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Aside",attrs:{"width":_vm.width}},[_c('el-tree',{ref:"tree",attrs:{"data":_vm.data,"props":_vm.treeConfig,"highlight-current":"","node-key":_vm.nodeKey,"default-expanded-keys":_vm.expandedKeys},on:{"node-click":_vm.selTree},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
var data = ref.data;
return _c('span',{staticClass:"tree-node"},[_c('span',[_vm._v(_vm._s(data[_vm.treeConfig.label]))])])}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }